import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './i18n'
import { 
  initPWAInstall, 
  registerServiceWorker, 
  enableBackgroundSync,
  enablePeriodicSync 
} from './utils/pwaInstall'

// Initialize PWA features
console.log('Initializing PWA features...');

// Register service worker
registerServiceWorker().then(async (registration) => {
  if (registration) {
    console.log('Service Worker registered successfully');
    
    // Enable background sync for messages
    await enableBackgroundSync('sync-messages');
    
    // Enable periodic sync for checking new matches (every 12 hours)
    await enablePeriodicSync('check-new-matches', 12 * 60 * 60 * 1000);
  } else {
    console.warn('Service Worker registration failed or not supported');
  }
}).catch((error) => {
  console.error('Service Worker registration error:', error);
});

// Initialize PWA install prompt
initPWAInstall();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
